import React, { useMemo } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

// Framer-motion AnimatePresence can return undefined in typings; ensure valid JSX for React 19
const AnimatePresenceSafe = AnimatePresence as React.FC<{
  mode?: "wait";
  children: React.ReactNode;
}>;

const prefersReducedMotion = (): boolean => {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

const PageTransition: React.FC = () => {
  const location = useLocation();
  const outlet = useOutlet();
  const reduceMotion = useMemo(() => prefersReducedMotion(), []);

  const transition = reduceMotion
    ? { duration: 0 }
    : { duration: 0.25, ease: "easeInOut" };

  const initial = reduceMotion
    ? {}
    : { opacity: 0, y: 12 };
  const animate = reduceMotion
    ? {}
    : { opacity: 1, y: 0 };
  const exit = reduceMotion
    ? {}
    : { opacity: 0, y: -8 };

  return (
    <div className="min-h-full w-full">
      <AnimatePresenceSafe mode="wait">
        {outlet && (
          <motion.div
            /* pathname only: React Router assigns a new location.key on search updates;
               keying on location.key remounts the outlet (e.g. digital reader ?p= sync → infinite reload). */
            key={location.pathname}
            initial={initial}
            animate={animate}
            exit={exit}
            transition={transition}
            className="min-h-full w-full"
          >
            {outlet}
          </motion.div>
        )}
      </AnimatePresenceSafe>
    </div>
  );
};

export default PageTransition;
